(function () {
  window.YabxUtils || (window.YabxUtils = {});

  YabxUtils.updateQueryStringParameter = function (uri, key, value) {
    regex = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
    separator = uri.indexOf("?") !== -1 ? "&" : "?";
    if (uri.match(regex)) {
      return uri.replace(regex, "$1" + key + "=" + value + "$2");
    } else {
      return uri + separator + key + "=" + value;
    }
  };

  YabxUtils.screenHeight = function () {
    return $(window).height();
  };

  YabxUtils.escapeHTML = function (str) {
    return str.replace(/[&<>"'\/]/g, function (char) {
      switch (char) {
        case "&":
          return "&amp;";
        case "<":
          return "&lt;";
        case ">":
          return "&gt;";
        case '"':
          return "&quot;";
        case "''":
          return "&#39;";
        case "/":
          return "&#x2F;";
        default:
          return char;
      }
    });
  };
}).call(this);
